import { useSelector } from "react-redux";
import { configurationCompanySetting, statusEnum } from "../../enums";
import { useTranslation } from "react-i18next";

export const formatEtaTime = (etaTime, compareTime) => {
  if (!etaTime) return "";
  const date = new Date(etaTime);
  if (isNaN(date.getTime())) return "";
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const h = hours % 12 || 12;
  const m = minutes.toString().padStart(2, '0');
  const time = `${h}:${m} ${ampm}`;
  if (compareTime) {
    const now = new Date(compareTime);
    if (!isNaN(now.getTime()) && (date.getMonth() !== now.getMonth() || date.getDate() !== now.getDate() || date.getFullYear() !== now.getFullYear())) {
      return `${date.getMonth() + 1}/${date.getDate()} ${time}`;
    }
  }
  return time;
}

export const isDelayedTimeCheck = (isOnMyWay, estimatedArrivalTime, exceptedExitTime, siteLocalTime) => {
    if (!siteLocalTime) return false;
    if (isOnMyWay && estimatedArrivalTime) {
        return is15MinutesPast(estimatedArrivalTime, siteLocalTime);
    }
    if (!isOnMyWay && exceptedExitTime) {
        return is15MinutesPast(exceptedExitTime, siteLocalTime);
    }
    return false;
}

export const is15MinutesPast = (etaTime, siteLocalTime) => {
  if (!etaTime || !siteLocalTime) return false;
  const eta = new Date(etaTime);
  const now = new Date(siteLocalTime);
  if (isNaN(eta.getTime()) || isNaN(now.getTime())) return false;
  const fifteenMin = 15 * 60 * 1000;
  return eta.getTime() < (now.getTime() - fifteenMin);
}

export const gridEtaTime =(params) => {
  const { t } = useTranslation();

  const statusItem = params.row;
  const orderStatus = statusItem?.order_status;
  const arrivalTime = statusItem?.arrival_time;
  const estimatedArrivalTime = statusItem?.estimated_arrival_time;
  const exceptedArrivalTime = statusItem?.excepted_arrival_time;
  const exceptedExitTime = statusItem?.excepted_exit_time;
  const siteLocalTime = statusItem?.site_local_time;
  const isDelayed = statusItem?.is_eta_delayed;

  const isOnMyWay = orderStatus === statusEnum["On my way"];
  const isEnRouteOrPickingUp = orderStatus === statusEnum["En-Route"] || orderStatus === statusEnum["Picking Up"];
  const companySettings = useSelector(state => state.authState.userData?.data?.company_settings);
  const enRouteEtaSetting = companySettings?.some(setting => setting.module_name === configurationCompanySetting.EnRouteEtaVisible);

  let etaText = "";

  if (arrivalTime) {
    etaText = `${t("OrdersTab.driverArrived")} : ${formatEtaTime(arrivalTime, siteLocalTime)}`;
  } else if (isDelayed || isDelayedTimeCheck(isOnMyWay, estimatedArrivalTime, exceptedExitTime, siteLocalTime)) {
    etaText = `${t("Dashboard.delayed")}`;
  } else if (enRouteEtaSetting && isEnRouteOrPickingUp && exceptedArrivalTime && exceptedExitTime) {
    etaText = `${formatEtaTime(exceptedArrivalTime, siteLocalTime)} - ${formatEtaTime(exceptedExitTime, exceptedArrivalTime)}`;
  } else if (isOnMyWay && estimatedArrivalTime) {
    etaText = `${formatEtaTime(estimatedArrivalTime, siteLocalTime)}`;
  }

  return (
    <span>
      {etaText ? etaText : "-"}
    </span>
  );
};
